import { Table } from '@seiue/ui'
import styled from 'styled-components'

/**
 * 自定义样式的Table
 */
export const StyledTable = styled(Table)`
  &&& {
    // thead样式调整
    .ant-table-thead > tr > th {
      height: 40px;
      padding: 0 0 0 16px;
      color: ${(props) => props.theme.text._1};
      font-weight: 500;
      background-color: ${(props) => props.theme.background._4};
      &:first-child {
        padding: 10px;
      }
    }
    // 去除表头分割线
    .ant-table-thead
      > tr
      > th:not(:last-child):not(.ant-table-selection-column):not(
        .ant-table-row-expand-icon-cell
      ):not([colspan])::before {
      display: none;
    }

    // tbody样式调整
    .ant-table-tbody > tr > td {
      height: 40px;
      padding: 0 0 0 16px;
      border-color: ${(props) => props.theme.border.greyNormal};
      color: ${(props) => props.theme.text._1};
      font-weight: 400;
      &:first-child {
        padding: 10px;
      }
    }

    // 字段数据为空时显示-
    .ant-table-cell:empty:after,
    .ant-table-cell > span:empty:after,
    .ant-table-cell > div:empty:after {
      content: '-';
    }

    // 选中行时的样式调整
    .ant-table tbody > tr.ant-table-row-selected > td {
      background-color: ${(props) => props.theme.background._5};
    }

    .ant-checkbox-checked .ant-checkbox-inner {
      background-color: ${(props) => props.theme.brand._1};
    }
    .ant-checkbox:hover {
      .ant-checkbox-inner {
        border-color: ${(props) => props.theme.brand._1};
      }
    }
    .ant-checkbox-indeterminate .ant-checkbox-inner::after {
      background-color: ${(props) => props.theme.brand._1};
    }

    // 分页器颜色修改
    .ant-table-pagination.ant-pagination {
      display: flex;
      align-items: center;
      font-size: 14px;
      margin: 14px 0 0 0;
    }
    .ant-select-selector {
      width: 120px;
      height: 32px;
      padding: 5px 12px;
      border: none;
      border-radius: 8px;
      font-weight: 400;
      background-color: #f0f5f5;
      & .ant-select-selection-item {
        font-size: 14px;
        line-height: 22px;
        color: ${(props) => props.theme.text._1};
        font-weight: 400;
      }
    }
    .ant-select-item-option-selected .ant-select-item-option-content {
      color: ${(props) => props.theme.brand._1};
    }
    .ant-pagination-item {
      border: transparent;
      font-size: 14px;
      color: ${(props) => props.theme.text._2};
      font-weight: 500;
    }
    .ant-pagination-item-link {
      border: transparent;
    }
    .ant-pagination-options {
      margin-left: 8px;
    }
    .ant-pagination-options-quick-jumper {
      color: ${(props) => props.theme.text._3};
      font-weight: 400;
    }
    .ant-pagination-options-quick-jumper input {
      width: 40px;
      height: 32px;
      border: transparent;
      border-radius: 8px;
      background-color: #f0f5f5;
    }
    .ant-pagination-item-active {
      border: none;
      border-radius: 8px;
      background-color: ${(props) => props.theme.brand._5};
      a {
        color: ${(props) => props.theme.brand._1};
      }
    }
    .ant-pagination-item:hover {
      a {
        color: ${(props) => props.theme.brand._1};
      }
    }
    .ant-pagination-prev:hover .ant-pagination-item-link {
      color: ${(props) => props.theme.brand._1};
    }
    .ant-pagination-next:hover .ant-pagination-item-link {
      color: ${(props) => props.theme.brand._1};
    }

    .ant-btn-link {
      color: ${(props) => props.theme.brand._1};
    }
  }
`
